import { INSIGHTS_PACKAGE } from '@atlassian/jira-insights-common-constants/src/common/constants/package';

export const BACKLOG_BUTTON_ID = `${INSIGHTS_PACKAGE}.backlog-button`;
